import ActivationPage from './ActivationPage';

export default ActivationPage;
